import { CardHeader, Badge, Box } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { ReactElement, ReactNode } from "react";
import Timestamp from "../../utility/Timestamp";

const useStyles = makeStyles((theme) => ({
    header: {
        padding: theme.spacing(1),

    },
    clickable: {
        cursor: "pointer"
    },
    action: {
        display: 'flex'
    },
    unread: {
        width: "10px",
        height: "10px",
        backgroundColor: "red",
        borderRadius: "5px"
    }
}));

interface Props
{
    onClick: () => void
    icon: ReactElement
    text: string | ReactNode
    children?: ReactNode
    timestamp: number
    read: boolean
}

export default function NotificationItem({ icon, text, read, children, timestamp, onClick }: Props)
{
    const classes = useStyles();

    return <CardHeader className={classes.header}
        avatar={
            <Badge variant={"dot"} badgeContent={read ? 0 : 1} color={"error"}>
                <Box className={classes.clickable} onClick={onClick}>{icon}</Box>
            </Badge>
        }
        action={
            <Box className={classes.action}>
                {children}
            </Box>
        }
        title={<Box className={classes.clickable} onClick={onClick}>{text}</Box>}
        subheader={<Box className={classes.clickable} onClick={onClick}>
            <Timestamp value={timestamp} />
        </Box>} />
}
